// Linkedin.js
import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import LanguageModal from "./LanguageModal";

const Linkedin = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.linkedin.com/in/mariela-ponce/",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text fade">LinkedIn</span>
        <Icon icon="bi:linkedin" />
      </button>
      {showModal && (
        <LanguageModal
          title="LinkedIn"
          icon="bi:linkedin"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Linkedin;
